import { ref } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { answerClasses } from './examClock';

export function useExamAnswers({ exam, attempt, answers, loading, submitting }) {
  const answerLocks = ref({});
  const answerFeedback = ref({});
  const textAnswers = ref({});
  const textDrafts = ref({});
  const savingAnswer = ref(false);
  let pending = Promise.resolve();

  const hydrateAnswerState = (data, restoreSelections = false) => {
    answerLocks.value = { ...(data.answer_locks || {}) };
    answerFeedback.value = { ...(data.answer_feedback || {}) };
    textAnswers.value = { ...(data.saved_text_answers || {}) };
    textDrafts.value = { ...textAnswers.value };
    if (restoreSelections) answers.value = { ...(data.saved_answers || {}) };
  };
  const saveSelection = (questionId, answerId, textAnswer = null) => {
    if (loading.value || submitting.value || savingAnswer.value || answerLocks.value[questionId]) return pending;
    const previous = { ...answers.value };
    const previousText = { ...textAnswers.value };
    answers.value = { ...answers.value, [questionId]: answerId };
    if (textAnswer !== null) textAnswers.value = { ...textAnswers.value, [questionId]: textAnswer };
    savingAnswer.value = true;
    pending = (async () => {
      try {
        const response = await axios.post('/exam-answers', {
          exam_id: exam.value.id, attempt: attempt.value, question_id: questionId,
          answer_id: answerId, text_answer: textAnswer,
        });
        hydrateAnswerState(response.data);
      } catch (error) {
        answers.value = previous;
        textAnswers.value = previousText;
        // Another device may have locked this answer. Reload the authoritative
        // selections rather than leaving this tab with stale, editable answers.
        if (error.response?.status === 409) {
          try {
            const response = await axios.get('/exam_web/' + exam.value.id);
            hydrateAnswerState(response.data, true);
          } catch (_) { /* Keep the last confirmed state if reload fails. */ }
        }
        Swal.fire('خطأ', error.response?.data?.message || 'تعذر حفظ الإجابة. برجاء المحاولة مرة أخرى.', 'error');
      } finally {
        savingAnswer.value = false;
      }
    })();
    return pending;
  };
  return {
    answerLocks, answerFeedback, textAnswers, textDrafts, savingAnswer, hydrateAnswerState,
    selectAnswer: (questionId, answerId) => saveSelection(questionId, answerId),
    saveTextAnswer: (questionId) => saveSelection(questionId, null, textDrafts.value[questionId] || ''),
    waitForAnswerSave: () => pending,
    optionClasses: (questionId, answerId) => answerClasses(questionId, answerId, answers.value, answerFeedback.value),
  };
}

